<template>
  <div>
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center titulo-sagres font-weight-bold">
          Prestações de Contas Mensais
          <b-button size="sm" class="float-right m-1" to="/entrega/enviar-pcm">
            <font-awesome-icon icon="plus" class="mr-3" />
            Enviar prestação
          </b-button>
        </h6>
      </template>
      <b-card-body>
        <card-filtros-busca>
          <b-form
            @submit.prevent="buscarPCMs"
            @reset.prevent="limparFiltros"
            v-if="showFilters"
          >
            <b-row>
              <b-col cols="12" md="6" lg="4">
                <b-form-group
                  id="input-group-type"
                  label-size="md"
                  label="ID da Prestação"
                >
                  <b-form-input v-model="filtros.codigo"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" lg="4">
                <b-form-group id="input-group-type" label-size="md" label="Ano">
                  <b-form-input v-model="filtros.ano"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" lg="4">
                <b-form-group id="input-group-type" label-size="md" label="Mês">
                  <b-form-input v-model="filtros.mes"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="6" lg="4">
                <b-form-group
                  id="input-group-type"
                  label-size="md"
                  label="Tipo de Entrega"
                >
                  <b-form-select
                    id="select-filtros-tipos-entrega"
                    v-model="filtros.tipoEntrega"
                    :options="comboTiposEntrega"
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6" lg="4">
                <b-form-group
                  id="input-group-type"
                  label-size="md"
                  label="Tipo de Prestação"
                >
                  <b-form-select
                    id="select-filtros-tipos-prestacao"
                    v-model="filtros.tipoPrestacao"
                    :options="comboTiposPrestacao"
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6" lg="4">
                <b-form-group
                  id="input-group-type"
                  label-size="md"
                  label="Situação"
                >
                  <b-form-select
                    id="select-filtros-situacao"
                    v-model="filtros.situacao"
                    :options="comboSituacoes"
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6" lg="4" class="pt-4">
                <b-button type="reset" variant="outline-secondary">
                  <font-awesome-icon icon="redo" class="mr-3" />Limpar
                </b-button>
              </b-col>
              <b-col cols="6" lg="4" class="pt-4">
                <b-button type="submit">
                  <font-awesome-icon icon="search" class="mr-3" />Filtrar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </card-filtros-busca>
        <b-table
          :busy="tableBusy"
          :fields="fields"
          hover
          no-border-collapse
          :items="items"
          sort-by=""
          :sort-desc="true"
          striped
          stacked="lg"
          responsive
          per-page="0"
          :current-page="currentPage"
          show-empty
        >
          <template #empty>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <div class="actions-icons lgvert2icones">
              <b-link v-if="row.item.DsStatusPc !== 'Em Fila'" class="text-dark" @click="verDetalhes(row.item)">
                <font-awesome-icon icon="eye" />
                <div style="font-size: 12px">Ver detalhes</div>
              </b-link>
              <b-link
                v-if="
                  (isDev || isHml) &&
                  row.item.Situacao === 'A'
                "
                class="text-dark"
                @click="alertaSimular(row.item)"
              >
                <font-awesome-icon icon="file-signature" />
                <div style="font-size: 12px">Simular assinatura</div>
              </b-link>
              <b-link
                v-if="row.item.Situacao === SITUACAO_EM_ANALISE && isAdmin"
                class="text-dark"
                @click="abrirModalCancelarPcm(+row.item.IdPrestacaoConta)"
              >
                <font-awesome-icon icon="ban" />
                <div style="font-size: 12px">Cancelar</div>
              </b-link>
              <b-link
                v-if="row.item.Situacao === 'P' && isAdmin"
                class="text-dark"
                @click="alertaReenvio(row.item)"
              >
                <font-awesome-icon icon="circle-check" />
                <div style="font-size: 12px">Liberar reenvio</div>
              </b-link>
            </div>
          </template>
        </b-table>
        <table-pagination
          v-if="totalRows"
          :total-rows="totalRows"
          per-page="10"
          @pageChange="novaPaginaPCMs"
        >
        </table-pagination>
      </b-card-body>
    </b-card>
    <b-modal
      id="modal-cancelar-pcm"
      size="md"
      button-size="sm"
      header-bg-variant="secondary"
      header-text-variant="light"
      header-class=""
      footer-class=""
      modal-class="p-2"
      no-close-on-backdrop
      no-close-on-esc
    >
      <template v-slot:modal-header="">
        <h5>Cancelar Prestação de Contas Mensal</h5>
      </template>
      <div>
        <p>
          Tem certeza que deseja cancelar a prestação de contas
          {{ pcmSelecionada }}?
        </p>
      </div>
      <template v-slot:modal-footer="">
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="fecharModalCancelarPcm()"
        >
          Fechar
        </b-button>
        <b-button size="sm" variant="secondary" @click="cancelarPcm()">
          Confirmar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from "vue-property-decorator";
import pcmService from "@/services/entregas/pcmService";
import { store, isAdmin, isDev, isHml } from "@/store";
import { PrestacaoDeContasMensal } from "@/types/entregas/pcm/prestacao-contas-mensal";
import { TableField } from "@/types/table-field";
import {
  fieldsPrestacaoContasMensal,
  codSituacoesEmFila,
} from "@/types/entregas/pcm/fields-prestacao-contas-mensal";
import { SelectValue } from "@/types/select-value";
import CardFiltrosBusca from "@/components/shared/CardFiltrosBusca.vue";
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import { FiltrosPrestacaoContasMensal } from "@/types/entregas/pcm/filtros-prestacao-contas-mensal";
import { PortalError } from "@/types/portal-error";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import type { SituacaoPcm } from "@/types/entregas/pcm/situacao-pcm";

const opcaoVaziaCombo = { text: "SELECIONE", value: "", disabled: true };

const CompProps = Vue.extend({
  name: "ConsultaRelatoriosLRFCI",
  components: { CardFiltrosBusca, TablePagination },
});

@Component
export default class ConsultaRelatoriosLRFCI extends mixins(
  UtilsTS,
  CompProps,
) {
  fields: TableField[] = fieldsPrestacaoContasMensal;
  filtros: FiltrosPrestacaoContasMensal = new FiltrosPrestacaoContasMensal();
  items: PrestacaoDeContasMensal[] = [];
  totalRows = 0;
  comboTiposEntrega: SelectValue[] = [];
  comboTiposPrestacao: SelectValue[] = [];
  comboSituacoes: SelectValue[] = [];
  showFilters = true;
  tableBusy = false;
  pcmSelecionada = -1;
  SITUACAO_EM_ANALISE = "Y";

  //paginação
  currentPage = 1;

  //Ambiente
  isDev = isDev();
  isHml = isHml();

  isAdmin = isAdmin();

  abrirModalCancelarPcm(idPcm: number): void {
    this.pcmSelecionada = idPcm;
    this.$bvModal.show("modal-cancelar-pcm");
  }

  fecharModalCancelarPcm(): void {
    this.pcmSelecionada = -1;
    this.$bvModal.hide("modal-cancelar-pcm");
  }

  async cancelarPcm(): Promise<void> {
    try {
      store.blockScreen = true;
      await pcmService.cancelarPcm(this.pcmSelecionada);
      await this.buscarPCMs();
      this.$toast.success(`Prestação de contas cancelada com sucesso.`);
      this.fecharModalCancelarPcm();
    } catch (err: unknown) {
      //TODO: Isso aqui tudo poderia ser só um this.tratarError(err)?
      console.error(err);
      if (err instanceof PortalError) {
        err.messages.map((msg) => this.$toast.error(msg));
      } else {
        const msg = err instanceof Error ? err.message : String(err);
        this.$toast.error(msg);
      }
    } finally {
      store.blockScreen = false;
    }
  }

  async mounted(): Promise<void> {
    try {
      store.blockScreen = true;
      this.filtros.limpar();
      await this.getCombos();
      await this.buscarPCMs();
    } finally {
      store.blockScreen = false;
    }
  }

  async getCombos(): Promise<void> {
    const combos = await pcmService.getCombosConsultaPCM();
    //TO DO: Centralizar o processamento desses arrays
    this.comboTiposEntrega = [
      { text: "SELECIONE", value: "", disabled: true },
      ...Object.keys(combos.tiposEntrega).map((key) => {
        return {
          text: combos.tiposEntrega[key],
          value: key,
        };
      }),
    ];
    this.comboTiposPrestacao = [
      { text: "SELECIONE", value: "", disabled: true },
      ...combos.tiposPrestacao.map((tr) => {
        return { text: tr.Descricao, value: tr.IdSistema };
      }),
    ];
    this.formatarComboSituacoes(combos.situacoes);
  }

  formatarComboSituacoes(listaSituacoes: SituacaoPcm[]): void {
    const tempSituacoes: SelectValue[] = [];
    listaSituacoes.forEach((s) => {
      if (codSituacoesEmFila.includes(s.Codigo)) {
        if (!tempSituacoes.some(opt => opt.text === "Em Fila")) {
          tempSituacoes.push({ text: "Em Fila", value: "1,10,14,15,16,17,19,20" });
        }
      } else {
        tempSituacoes.push({ text: s.DsStatusPc, value: s.IdStatusPc });
      }
    });
    this.comboSituacoes = [];
    this.comboSituacoes.push(opcaoVaziaCombo);
    tempSituacoes.forEach((s) => this.comboSituacoes.push(s));
  }

  novaPaginaPCMs(page: string|number): void {
    this.currentPage = +page;
    this.buscarPCMs();
  }
  async buscarPCMs(): Promise<void> {
    this.tableBusy = true;
    try {
      const response = await pcmService.consultarPrestacoes(
        this.filtros,
        this.currentPage,
      );
      //TODO: Tratar isto no pcmService.consultarPrestacoes, receber return object com array de pcms
      if (response && response.status === 200) {
        this.items = response.data.prestacoes.map((pcm: any) => {
          const retorno = Object.assign(new PrestacaoDeContasMensal(), pcm);
          retorno.tratarDadosDaAPI();
          return retorno;
        });
        this.totalRows = response.data.totalRows;
      } else {
        throw new Error(
          response.data && response.data.msg
            ? response.data.msg
            : "Ocorreu um erro ao realizar a consulta. Verifique se os filtros de pesquisa aplicados podem ser refinados!",
        );
      }
    } catch (e: unknown) {
      console.error(e);
      this.items = [];
      this.totalRows = 0;
      this.$toast.error(e instanceof Error ? e.message : String(e));
    } finally {
      this.tableBusy = false;
    }
  }
  verDetalhes(pcmSelecionada: PrestacaoDeContasMensal): void {
    this.$router.push(
      `/entrega/prestacoes-contas-mensais/${pcmSelecionada.IdPrestacaoConta}`,
    );
  }
  limparFiltros(): void {
    this.filtros.limpar();
    // Trick to reset/clear native browser form validation state
    this.showFilters = false;
    this.$nextTick(() => {
      this.showFilters = true;
    });
  }

  async simularAssinatura(id: number): Promise<void> {
    try {
      store.blockScreen = true;
      await pcmService.simularAssinatura(id);
      await this.buscarPCMs();
      this.$toast.success("Assinatura simulada com sucesso!");
    } catch (e: unknown) {
      this.tratarError(e);
    } finally {
      store.blockScreen = false;
    }
  }

  async liberarReenvio(id: number): Promise<void> {
    try {
      store.blockScreen = true;
      await pcmService.liberarReenvio(id);
      await this.buscarPCMs();
      this.$toast.success("Reenvio liberado com sucesso!");
    } catch (e: unknown) {
      this.tratarError(e);
    } finally {
      store.blockScreen = false;
    }
  }

  alertaSimular(pcm: PrestacaoDeContasMensal): void {
    this.$bvModal
      .msgBoxConfirm(
        `Deseja simular a assinatura da PCM de ID ${pcm.IdPrestacaoConta}?`,
        {
          buttonSize: "sm",
          cancelTitle: "Cancelar",
          cancelVariant: "outline-secondary",
          okVariant: "secondary",
          centered: true,
          headerBgVariant: "secondary",
          headerTextVariant: "light",
          okTitle: "Confirmar",
          title: "Simular assinatura",
        },
      )
      .then((value) => {
        if (value) this.simularAssinatura(pcm.IdPrestacaoConta);
      })
      .catch((err) => {
        console.error(
          `Erro ao operar o dialogo de alerta para simular assinatura`,
          err,
        );
      });
  }

  alertaReenvio(pcm: PrestacaoDeContasMensal): void {
    this.$bvModal
      .msgBoxConfirm(
        `Deseja liberar para reenvio a PCM de ID ${pcm.IdPrestacaoConta}?`,
        {
          buttonSize: "sm",
          cancelTitle: "Cancelar",
          cancelVariant: "outline-secondary",
          okVariant: "secondary",
          centered: true,
          headerBgVariant: "secondary",
          headerTextVariant: "light",
          okTitle: "Confirmar",
          title: "Simular assinatura",
        },
      )
      .then((value) => {
        if (value) this.liberarReenvio(pcm.IdPrestacaoConta);
      })
      .catch((err) => {
        console.error(
          `Erro ao operar o dialogo de alerta para liberar para reenvio`,
          err,
        );
      });
  }
}
</script>
